module.exports = "//static.hsappstatic.net/settings-ui-app/static-1.16253/images/double-opt-in-turn-off.jpg"